// extracted by mini-css-extract-plugin
module.exports = {"connect-to-social-account-link":"inspector_connect-to-social-account-link__PbdZg"};